export enum LDFlags {
  SHOW_RECURRING_VISITOR = 'showRecurringVisitor',
}
